import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

export const getReclamationsByRestaurant = async (
  page = 1,
  limit = 10,
  search = "",
  type = "",
  status = "",
  dateFrom = "",
  dateTo = "",
  archived = false
) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (type) params.append("type", type);
    if (status) params.append("status", status);
    if (dateFrom) params.append("dateFrom", dateFrom);
    if (dateTo) params.append("dateTo", dateTo);
    if (archived) params.append("archived", "true");

    const response = await axios.get(
      `${config.dev}/client-reclamation/restaurant?${params.toString()}`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching reclamations:", error);
    throw error.response?.data || { message: "Error fetching reclamations" };
  }
};

export const getReclamationById = async (id) => {
  try {
    const response = await axios.get(`${config.dev}/client-reclamation/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching reclamation:", error);
    throw error.response?.data || { message: "Error fetching reclamation" };
  }
};

export const updateReclamationStatus = async (id, status) => {
  try {
    const response = await axios.put(
      `${config.dev}/client-reclamation/status/${id}`,
      { status },
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating reclamation status:", error);
    throw error.response?.data || { message: "Error updating reclamation status" };
  }
};

export const archiveReclamation = async (id) => {
  try {
    const response = await axios.put(
      `${config.dev}/client-reclamation/archive/${id}`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error archiving reclamation:", error);
    throw error.response?.data || { message: "Error archiving reclamation" };
  }
};

export const restoreReclamation = async (id) => {
  try {
    const response = await axios.put(
      `${config.dev}/client-reclamation/restore/${id}`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error restoring reclamation:", error);
    throw error.response?.data || { message: "Error restoring reclamation" };
  }
};

export const deleteReclamation = async (id) => {
  try {
    const response = await axios.delete(`${config.dev}/client-reclamation/delete/${id}`, {
      headers: authHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting reclamation:", error);
    throw error.response?.data || { message: "Error deleting reclamation" };
  }
};
